<script>
import { mapActions, mapState } from "vuex";
import List from "./components/List";

const PROFESSIONAL_TRAINING_STEPS = [
  "pending",
  "in_training",
  "training_completed",
  "training_incompleted"
];

export default {
  title: "Treinamento Profissionais",

  components: {
    List
  },

  methods: {
    ...mapActions("professionalTrainingFlow", ["setTextSearch"]),

    getStep(step) {
      return this[step];
    }
  },

  computed: {
    ...mapState("professionalTrainingFlow", PROFESSIONAL_TRAINING_STEPS),

    steps() {
      return PROFESSIONAL_TRAINING_STEPS;
    }
  }
};
</script>

<template>
  <div class="box">
    <div class="header">
      <div class="title">PROFISSIONAIS EM FASE DE TREINAMENTO</div>

      <input
        @keypress.enter="setTextSearch($event.target.value)"
        type="text"
        placeholder="buscar"
        class="with-icon icon-search sm text-lowercase"
      />
    </div>

    <div class="list-container">
      <template v-for="step in steps">
        <List :key="step" :data="getStep(step)" :type="step" />
      </template>
    </div>
  </div>
</template>

<style scoped>
.box {
  height: calc(100% - 60px);
  max-height: 100%;
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

input {
  border-bottom: solid 1px #424242;
}

.list-container {
  height: calc(100% - 30px);
  display: flex;
  width: auto;
  overflow-x: scroll;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfessionalTrainingFlow/Index.vue